import { useEffect, useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Portfolio from "@/components/site/Portfolio";
import Featured from "@/components/site/Featured";
import Team from "@/components/site/Team";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { getProperties } from "@/lib/api";

export default function Home() {
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    getProperties()
      .then(setProperties)
      .catch((e) => console.error("Failed to load properties", e));
  }, []);

  return (
    <main className="bg-[#F7F5F0] text-[#1C2220] antialiased" data-testid="home-page">
      <Header />
      <Hero />
      <EditorialMarquee />
      <About />
      <Portfolio properties={properties} />
      <Featured properties={properties} />
      <Team />
      <Contact />
      <Footer />
    </main>
  );
}
